import './ArchiveAutoRent.scss';
ComponentManager.init( document.body );